import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Formik, Form, Field } from 'formik';
import { connect } from 'react-redux';
import { TextField } from 'formik-material-ui';
import { Link } from 'gatsby-theme-material-ui';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import { getOr } from 'lodash/fp';
import { useTranslation } from 'react-i18next';

import CustomInputField from '../custom/CustomInputField';
import { SignInValidation } from './validation';
import { auth, alert, merchant } from '../../state';

const SignInForm = ({ login, setAlert, setUser, getMerchantDetails }) => {
  const { t } = useTranslation();
  return (
    <Formik
      validationSchema={SignInValidation}
      initialValues={{
        email: '',
        password: '',
      }}
      onSubmit={async (values, actions) => {
        const result = await login(values);
        const payload = getOr('', ['payload'], result);
        const role = getOr('', ['payload', 'role'], result);
        const token = getOr('', ['payload', 'jwtToken'], result);
        const error = getOr('', ['error', 'message'], result);

        if (error) {
          setAlert({ message: error, severity: 'error' });
          actions.setErrors({ email: ' ', password: ' ' });
        }
        if (!error && role !== 'Merchant' && role !== 'MerchantAdmin') {
          setAlert({
            message: t('merchantLoginOnly'),
            severity: 'error',
          });
          setUser({});
        }
        if (
          (role === 'Merchant' || role === 'MerchantAdmin') &&
          !error &&
          token
        ) {
          const res = await getMerchantDetails(payload);
          const isConnected = getOr(
            false,
            ['payload', 'merchantConnected'],
            res
          );
          const hasLocationId = !!getOr('', ['payload', 'locationId'], res);
          if (!isConnected && !hasLocationId) {
            navigate('/dashboard/connect');
            return null;
          }
          navigate('/dashboard');
          return null;
        }
        return null;
      }}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Form>
            <Box pb={2}>
              <CustomInputField
                customInput={Field}
                component={TextField}
                trim
                fullWidth
                required
                type="email"
                label={t('email')}
                name="email"
                variant="outlined"
              />
            </Box>
            <Box>
              <Field
                component={TextField}
                fullWidth
                required
                type="password"
                label={t('password')}
                name="password"
                variant="outlined"
              />
            </Box>
            <Box align="right" pb={2}>
              <Link to="/forgot-password">
                <Typography variant="caption" color="textSecondary">
                  {`${t('forgotPassword')}?`}
                </Typography>
              </Link>
            </Box>
            <Box pb={2}>
              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                onClick={handleSubmit}
                size="large"
                // style={{backgroundColor: '#EE6C4D'}}
              >
                {isSubmitting ? <CircularProgress size={24} /> : t('signin')}
              </Button>
            </Box>
            <Box align="center">
              <Link to="/register">
                <Typography variant="caption" color="textSecondary">
                  {t('newToPintuna')} <b>{t('register')}</b>.
                </Typography>
              </Link>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

SignInForm.propTypes = {
  login: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  getMerchantDetails: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  login: (payload) => dispatch(auth.actions.login(payload)),
  logout: () => dispatch(auth.actions.login()),
  setUser: (payload) => dispatch(auth.actions.setUser(payload)),
  setAlert: (payload) => dispatch(alert.actions.open(payload)),
  getMerchantDetails: (payload) =>
    dispatch(merchant.actions.getMerchantDetails(payload)),
});

export default connect(null, mapDispatchToProps)(SignInForm);
